import { render, staticRenderFns } from "./ProjectsListItem.vue?vue&type=template&id=5d18c27b&scoped=true"
import script from "./ProjectsListItem.vue?vue&type=script&lang=js"
export * from "./ProjectsListItem.vue?vue&type=script&lang=js"
import style0 from "./ProjectsListItem.vue?vue&type=style&index=0&id=5d18c27b&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d18c27b",
  null
  
)

export default component.exports